import type { APIClient } from '@src/shared/api';

import { useMutation } from '@src/shared/query';

export type PasswordChangePayload = {
  password: string;
  otp_code: string;
};

type PasswordChangeResponse = {
  detail: string;
};

export function usePasswordChange() {
  return useMutation<PasswordChangeResponse, Error, PasswordChangePayload>({
    mutationKey: ['auth', 'password-change'],
    mutateFn: ({
      apiClient,
      ...payload
    }: { apiClient: APIClient } & Record<string, unknown>) => {
      return apiClient.request({
        url: `${import.meta.env.VITE_AUTH_DOMAIN}/api/v1/auth/password/change/`,
        method: 'POST',
        payload,
      }) as Promise<PasswordChangeResponse>;
    },
  });
}
